module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-poland.ab82209b.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-poland.png
// module id = 2630
// module chunks = 11